import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import styled from "styled-components";
import store from "./redux/store";
import "./App.css";
import { ThemeProvider } from "./ThemedContext/Provider";
import Dashboard from "./pages/Home";
import Login from "./pages/LoginForm";
import RegisterForm from "./pages/RegisterForm";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AllAlbums from "./pages/AllAlbums";
import Footer from "./components/Footer";
import AllSongs from "./pages/AllSongs";
import ArtisteDashboard from "./components/ArtisteDashboard/index";
import { PrivateRoute } from "./components/ProtectedRoute";
import "bootstrap/dist/css/bootstrap.min.css";
import Navs from "./components/NewNavBar";

// Call it once in your app. At the root of your app is the best place
toast.configure({
  autoClose: 8000,
  draggable: false,
  //etc you get the idea
});

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <Wrapper>
          <Router>
            <Navs />
            <Switch>
              <Route exact path='/'>
                <Dashboard />
              </Route>
              <PrivateRoute
                exact
                path='/artist'
                component={ArtisteDashboard}
              />
              <Route exact path='/songs'>
                <AllSongs />
              </Route>
              <Route exact path='/albums'>
                <AllAlbums />
              </Route>
              <Route exact path='/login'>
                <Login />
              </Route>
              <Route exact path='/register'>
                <RegisterForm />
              </Route>
              <Footer />
            </Switch>
          </Router>
          <Footer />
        </Wrapper>
      </ThemeProvider>
    </Provider>
  );
}

export const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export default App;
